export const SWIPE_SENS = 50;
